<div class="profile-container pb-7">
  <div class="authorization-title"><rkt-icon name="card" />Authorization Details</div>

  <div class="preview-container pl-7">
    <div class="preview-details">
      <div class="label">Start Date</div>
      <div class="value">{{ authorization?.startDate }}</div>
    </div>
    @if (authorization?.endDate) {
      <div class="details-separator"></div>
      <div class="preview-details">
        <div class="label">End Date</div>
        <div class="value">{{ authorization?.endDate }}</div>
      </div>
    }
    <div class="details-separator"></div>
    <div class="preview-details">
      <div class="label">OccurrenceType</div>
      <div class="value">{{ authorization?.occurrenceType }}</div>
    </div>
    @if (authorization?.paymentFrequency) {
      <div class="details-separator"></div>
      <div class="preview-details">
        <div class="label">Frequency</div>
        <div class="value">{{ authorization?.paymentFrequency }}</div>
      </div>
    }
    <div class="details-separator"></div>
    <div class="preview-details">
      <div class="label">Transaction Amount</div>
      <div class="value">{{ authorization?.amount }}</div>
    </div>
    <div class="details-separator"></div>
    <div class="preview-details">
      <div class="label">Currency</div>
      <div class="value">{{ authorization?.currency }}</div>
    </div>
    <div class="details-separator"></div>
    <div class="preview-details">
      <div class="label">Date of Agreement</div>
      <div class="value">{{ authorization?.dateOfAgreement ?? todayDate }}</div>
    </div>
  </div>
</div>
